import feature1 from "../imgs/feature/feature1.svg";
import feature2 from "../imgs/feature/feature2.svg";
import feature3 from "../imgs/feature/feature3.svg";
import feature4 from "../imgs/feature/feature4.svg";

export const GameFeatureData = [
    {
        id: 1,
        title: "Fitness First",
        des: "The core of the experience relies on a solid fitness app with metric tracking and allows the player to make their own goals.",
        img: feature1,
        bgColor: "bg1",
    },
    {
        id: 2,
        title: "Immersive Narrative Mystery",
        des: "A fragmented narrative that players experience in chunks every time they play a mission. (As the player unlocks more missions and meets more characters, the plot unfolds and a web of mystery is uncovered.",
        img: feature2,
        bgColor: "bg2",
    },
    {
        id: 3,
        title: "Players own their progression",
        des: "Players will be rewarded DOSE directly for their engagement in the game, along with NFTs. Players who jump into the game early are especially valuable to the community and will find themselves with more opportunities to accelerate their progression.",
        img: feature3,
        bgColor: "bg3",
    },
    {
        id: 4,
        title: "Free to Play economy",
        des: "Players can get started in the game for free. The core of the economy revolves around players feeling like they’re scavenging loot and crafting junk up into something magical (literally!).",
        img: feature4,
        bgColor: "bg4",
    },
];
